'use client';

import React from 'react';

import { ImageTransformationKeys } from '@/types/files/files.types';
import { directusImageLoader } from '@/utils/loaders';

type Props = {
  imageKeys: ImageTransformationKeys;
  imageSrc?: string | undefined;
  alt?: string;
  width?: number;
  height?: number;
  className?: string;
  loading?: 'lazy' | 'eager';
  additionalParams?: Record<string, string>;
  quality?: number;
  mobileImageSrc?: string;
  desktopImageSrc?: string;
};

const CustomImage = ({
  imageKeys,
  imageSrc,
  mobileImageSrc,
  desktopImageSrc,
  alt = '',
  width = 1440,
  height = 680,
  // className = '',
  loading = 'lazy',
  additionalParams = {},
  quality,
}: Props) => {
  // const common = {
  //   alt: alt,
  //   width: width,
  //   height: height,
  //   loader: directusImageLoader,
  //   priority: loading === 'eager' ? true : false,
  // };

  const buildSrc = (key: string, imageSrc: string | undefined) => {
    if (!imageSrc) return '';
    const params = new URLSearchParams({ ...additionalParams, key });

    if (quality !== undefined) {
      params.append('quality', quality.toString());
    }
    return `${imageSrc}?${params.toString()}`;
  };

  const mobileSrc = directusImageLoader({
    src: buildSrc(imageKeys.mobileKey, mobileImageSrc ?? imageSrc),
    width: 768,
    quality,
  });

  const desktopSrc = directusImageLoader({
    src: buildSrc(imageKeys.desktopKey, desktopImageSrc ?? imageSrc),
    width: 1920,
    quality,
  });

  return (
   <picture>
      <source media="(max-width:575px)" srcSet={mobileSrc} />
      <source media="(min-width:576px)" srcSet={desktopSrc} />
      <img
        src={mobileSrc}
        alt={alt}
        title={alt}
        width={width}
        height={height}
        loading={loading}
        fetchPriority={loading === 'eager' ? 'high' : 'auto'}
      />
    </picture>
  );
};

export default CustomImage;

